import { componentMapClient } from '../page-template/component-map';
import { type GenericConfig } from '~/types';
import { type ComponentStateType } from '~/types/template';
import { invalidDehydratedState } from '~/utils/invalidDehydratedState.ts';

import { isGroupComponent } from './isGroupComponent';

export function renderComponents({
  components,
  genericConfig,
}: {
  components: ComponentStateType[] | null;
  genericConfig: GenericConfig;
}) {
  if (!components) return null;

  return components.map((component, index) => {
    const id = component?.id ?? `failed-component-${index}`;

    try {
      const componentState = component.componentState;
      const name = component.name;
      const componentObj = componentMapClient[name];
      if (!componentObj) return null;
      const Component = componentObj.Component;

      const componentProps = isGroupComponent(name) ? component : component.componentArgs;

      if (invalidDehydratedState(component.componentState)) return null;
      return <Component {...genericConfig} {...componentProps} dehydratedState={componentState} key={id} />;
    } catch (error: any) {
      return (
        <div
          dangerouslySetInnerHTML={{
            __html: `Failed to render component: ${component}`,
          }}
          data-component-id={id}
          key={id}
          style={{ display: 'none' }}
        />
      );
    }
  });
}
